import type { ComponentProps } from "react";

import { cn } from "../../lib/utils";

// Campo de busca em "pílula" (ícone + input sem borda), calibrado para
// reproduzir 1:1 as regras-base `.global-search` (+ `svg`, `input` e
// `::placeholder`) de styles.css. Usado na busca global da topbar e na busca de
// eventos da tela Atividade — por isso vira componente, e não utilitárias soltas
// no JSX. As utilitárias usam valores arbitrários onde o design foge da escala
// padrão, de propósito: a meta desta fase é preservar o visual enquanto o estilo
// migra do CSS global para o componente. Ver docs/design/ui-foundation.md.
//
// As larguras responsivas (`max-[980px]` e `max-[720px]`) vinham das media
// queries globais e valiam para os dois consumidores; ficam aqui para manter o
// comportamento idêntico. `[outline:0]` é literal (e não `outline-0`) porque
// precisa anular o `:focus-visible` global — o campo desenha o foco no
// contêiner, não no input. E leva `!` (TUT-472): aquela regra mora FORA de
// layer e vence qualquer utilitária sem ele.
type SearchFieldProps = ComponentProps<"form">;

export function SearchField({ className, ...props }: SearchFieldProps) {
  return (
    <form
      className={cn(
        // TUT-282 — h-[2.55rem] era um dos seis valores soltos; agora lê do
        // token padrão (--control-h, 2.5rem).
        "global-search flex h-[var(--control-h)] w-[min(440px,46vw)] items-center rounded-[7px] border border-border bg-[color-mix(in_srgb,var(--surface)_78%,transparent)] px-[0.75rem]",
        "max-[980px]:w-[min(450px,calc(100vw_-_12rem))] max-[720px]:w-full",
        "[&_svg]:flex-[0_0_auto] [&_svg]:text-[var(--muted)]",
        // TUT-113c: o input perde o contorno (o campo visual e o INVOLUCRO), entao
        // e o involucro que precisa mostrar o foco — sem isto, quem navega por
        // teclado nao ve onde esta (WCAG 2.4.7).
        "has-[:focus-visible]:border-focus has-[:focus-visible]:shadow-[0_0_0_3px_var(--focus-highlight)]",
        "[&_input]:text-ellipsis [&_input::placeholder]:text-ellipsis",
        "[&_input]:h-full [&_input]:min-w-0 [&_input]:flex-1 [&_input]:border-0 [&_input]:bg-transparent [&_input]:px-[0.65rem] [&_input]:text-[var(--text)] [&_input]:not-forced-colors:![outline:0] [&_input]:placeholder:text-[var(--muted)]",
        className,
      )}
      {...props}
    />
  );
}
